import Vue from 'vue'
import Vuex from 'vuex'
import { get } from 'lodash-es'
import { getChanel } from '@/api'
import getters from './getters'
Vue.use(Vuex)
const modulesFiles = require.context('./modules', true, /\.js$/)
// 它将自动要求模块文件中的所有vuex模块
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
export default new Vuex.Store({
  state: {
    // get/channel 接口返回的数据
    globalChannelInfo: null,
    loading: {
      status: true,
      text: '',
    },
    // 渠道开通的所有卡种
    cardTypes: [],
    globalErrorMessage: '系统错误，请刷新重试！',
    channel: '',
    oldCardTypes: [],
    oneBtnZujian46: false,
    chekaCardCityName: '', // 负责处理下单失败切卡逻辑
  },
  modules,
  getters,
  mutations: {
    SET_GLOBAL_CHANNEL_INFO(state, info) {
      state.globalChannelInfo = info
    },
    SET_CHEKACARDCITYNAME(state, data) {
      state.chekaCardCityName = data
    },
    SET_ONEBTNZUJIAN46(state, oneBtnZujian46) {
      state.oneBtnZujian46 = oneBtnZujian46
    },
    SET_CARD_TYPES(state, list) {
      state.cardTypes = list
    },
    SET_OLDCARD_TYPES(state, list) {
      state.oldCardTypes = list
    },
    SET_CHANNEL(state, channel) {
      state.channel = channel
    },
    updateLoadingStatus(state, status) {
      state.loading.status = status.status
      state.loading.text = status.text
    },
    SET_ISSONCARD(state, isSonCard) {
      state.isSonCard = isSonCard
    },
  },
  actions: {
    async serverInit({ commit, dispatch }, params) {
      if (!params.channel) {
        return commit('SET_GLOBAL_CHANNEL_INFO', null)
      }
      try {
        const resp = await getChanel({ ...params, ip: '', flag: true })
        if (resp.status === 1) {
          const imageUrlInfo = get(resp, 'otherData.imageUrlInfo', [])
          let defaultCity = get(resp, 'otherData.defaultCity', null)
          if (defaultCity) commit('SET_CHEKACARDCITYNAME', defaultCity)

          // if (true) commit('SET_CHEKACARDCITYNAME', `上海市`)

          const defaultCardType = get(resp, 'otherData.defaultCardType', [])
          const { otherData } = resp
          /**
           * 这个逻辑可以参数
           */
          imageUrlInfo.forEach((t, i) => {
            // 默认选择第一个卡种
            t.is_checked = i === 0 || false
          })
          commit('SET_CHANNEL', params.channel)
          /**
           * 2023-11-08增加ip 切卡功能
           */
          if ([8, 9].includes(Number(otherData.backgroundImageType)) && defaultCardType && defaultCardType.length > 0) {
            commit('SET_CARD_TYPES', defaultCardType)
            commit('SET_OLDCARD_TYPES', imageUrlInfo)
            dispatch(`public/setCard`, defaultCardType[0])
          } else {
            commit('SET_CARD_TYPES', imageUrlInfo)
            commit('SET_OLDCARD_TYPES', imageUrlInfo)
            dispatch(`public/setCard`, imageUrlInfo[0])
          }
          commit('SET_GLOBAL_CHANNEL_INFO', resp)
        }
      } catch (error) {
        console.log(`serverInit报错=====》`, error)
        return commit('SET_GLOBAL_CHANNEL_INFO', null)
      }
    },
    startLoding({ state, commit }, status) {
      commit('updateLoadingStatus', { status, text: '加载..' })
    },
    setOneBtnZujian46({ commit }, btn) {
      commit('SET_ONEBTNZUJIAN46', btn)
    },
    setCardTypes({ commit }, listData) {
      commit('SET_CARD_TYPES', listData)
    },
  },
})
